module.exports = __webpack_public_path__ + "img/white_black_logo.c76dd764.svg";